import { Middleware } from '@reduxjs/toolkit';
import {
  startChat,
  sendMessage, endChat,
  sendTypingMessage,
  sendAgentRead
} from './slices/trafficSlice';
import { getWebSocketService } from './WebSocketServiceSingleton';

const webSocketMiddleware: Middleware = store => next => action => {




  if (startChat.match(action)) 
  {
    const { customerId, message, ownerToken, messageId, token, avatar_url, agent_name } = action.payload;
    const chatPayload = {
      action: 'start_chat',
      payload: {
        customer_id: customerId,
        message: message,
        owner_token: ownerToken,
        messageId: messageId,
        token: token,
        avatar_url: avatar_url,
        agent_name: agent_name
      }
    };


    const wsService = getWebSocketService(); // Access the singleton instance

    const serializedPayload = JSON.stringify(chatPayload);
    wsService.sendMessage(serializedPayload);
  }
  else if (endChat.match(action)) 
    {
      const { messageId, customerId, message, ownerToken, license_uuid } = action.payload;
  

  
      const chatPayloadMessage = {
        action: 'agent_ending_chat_to_socket',
        payload: {
          messageId: messageId,
          type: 'agent',
          cid: customerId,
          message: message
        },
        owner_token: ownerToken,
        license_uuid: license_uuid
      };

      console.log("sending this to the socket ", chatPayloadMessage)
  
      const wsService = getWebSocketService(); // Access the singleton instance
      const serializedPayload = JSON.stringify(chatPayloadMessage);
  
      wsService.sendMessage(serializedPayload);
    }  
  else if (sendMessage.match(action)) 
  {
    const { messageId, customerId, message, ownerToken, avatar_url, agent_name, attachment } =
      action.payload;

    const chatPayloadMessage = {
      action: 'agent_sending_message',
      payload: {
        messageId: messageId,
        type: 'agent',
        cid: customerId,
        message: message,
        attachment: attachment || null
      },
      owner_token: ownerToken,
      avatar_url: avatar_url,
      agent_name: agent_name
    };

    const wsService = getWebSocketService(); // Access the singleton instance
    const serializedPayload = JSON.stringify(chatPayloadMessage);

    wsService.sendMessage(serializedPayload);
  } 
  else if (sendTypingMessage.match(action)) 
  {
    const { customerId, ownerToken } = action.payload;

    console.log(action.payload);

    const chatPayloadMessage = {
      action: 'agent_typing_message',
      payload: {
        type: 'agent',
        cid: customerId
      },
      owner_token: ownerToken
    };

    const wsService = getWebSocketService();
    const serializedPayload = JSON.stringify(chatPayloadMessage);

    wsService.sendMessage(serializedPayload);
  }
  else if (sendAgentRead.match(action))
  {
    const { customerId } = action.payload;
    const wsService = getWebSocketService();
    wsService.sendMessage(
      JSON.stringify({ action: 'agent_read', payload: { type: 'agent', cid: customerId } })
    );
  }

  return next(action);
};

export default webSocketMiddleware;
